import { render, staticRenderFns } from "./MarketReportResult.vue?vue&type=template&id=e497fbcc&scoped=true&"
import script from "./MarketReportResult.vue?vue&type=script&lang=js&"
export * from "./MarketReportResult.vue?vue&type=script&lang=js&"
import style0 from "./MarketReportResult.vue?vue&type=style&index=0&id=e497fbcc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e497fbcc",
  null
  
)

export default component.exports